import Model from './model'

class Subscription extends Model({
  memberships: undefined,
  selectedSubscription: undefined,
  invoice: undefined,
}) {}

export default Subscription
